import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { actions } from 'onion-form';
import { connect } from 'react-redux';

import DateModal from './date_modal';

@connect(null, { setFieldValue: actions.setFieldValue, onionLiveValidate: actions.onionLiveValidate })
export default class DateFieldComponent extends React.Component {
  static propTypes = {
    error: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onionFormName: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    onionLiveValidate: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
  };

  static defaultProps = {
    error: undefined,
    required: false,
    Component: null,
    type: 'text'
  };

  constructor(props) {
    super(props);

    this.state = {
      showModal: false
    };
  }

  onDateChange(value) {
    const { name, onionFormName, setFieldValue, onionLiveValidate } = this.props;

    this.setState({ showModal: false });
    setFieldValue(onionFormName, name, value);
    onionLiveValidate(onionFormName, name);
  }

  render() {
    const { error, label, required, value } = this.props;
    let hint = null;
    let validationState = null;

    switch (error) {
      case 'invalid':
        hint = 'Neplatná hodnota';
        validationState = 'error';
        break;
      case 'required':
        hint = 'Povinný údaj';
        validationState = 'error';
        break;
    }

    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>
          {required && <abbr title="vyžadováno">*&nbsp;</abbr>}
          {label}
        </ControlLabel>
        <FormControl
          {...this.props}
          onClick={() => this.setState({ showModal: true })}
          value={value && value.format('DD.MM.YYYY H:mm')}
        />
        <DateModal
          onChange={this.onDateChange.bind(this)}
          onHide={() => this.setState({ showModal: false })}
          show={this.state.showModal}
          value={value && value.format('DD.MM.YYYY H:mm')}
        />
        { hint && <HelpBlock>{hint}</HelpBlock> }
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/date_field_component.jsx